import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ScheduleOptionsProp } from '../models/Exam';
import { QuestionserviceService } from '../services/questionservice.service';
//import { OptionDetails } from '../models/model';

@Component({
  selector: 'app-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss']
})
export class OptionComponent implements OnInit, AfterViewInit, OnChanges {
  @Input()
  option: ScheduleOptionsProp;
  @Input() schedulequestionid:number;
  @ViewChild('optionhtmlspan') optionhtmlspan: ElementRef;
  @Output()
  radioSelected: EventEmitter<ScheduleOptionsProp> = new EventEmitter();
  @ViewChild('optionInput') optionInput: ElementRef;
  constructor() { }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.setOption();
  }
  ngAfterViewInit(): void {
    this.setOption();
  }

  setOption(){
    if(this.optionhtmlspan){
      if(this.option){
        this.optionhtmlspan.nativeElement.innerHTML =  this.option.optionhtml;
        this.optionhtmlspan.nativeElement = QuestionserviceService.cleanMathFieldValues(this.optionhtmlspan.nativeElement);
      }
      else{
        this.optionhtmlspan.nativeElement.innerHTML =  '';
      }
    }
  }

  

  ngOnInit(): void {
  }
  onRadioButtonClick(option: ScheduleOptionsProp) {
    //this.disableradios(true)
    console.log(`checked: ${this.optionInput.nativeElement.checked}`);
    this.radioSelected.emit(option);
  }
  // disableradios(disable: boolean) {
  //   var buttons = document.getElementsByName(this.schedulequestionid.toString());
  //   buttons.forEach(this.radiodiabbletoggle)
  // }
  // radiodiabbletoggle(button) {
  //   button.disabled = true;
  // }
}
